<template>
  <div class="w-100">
    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
      :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :navigationField="'partNumber'"
      @checkedItem="checkedRowItemIds=$event"
    />
    <edit-line v-if="fromEditPage && (checkClaim(CAN_EDIT_WORK_ORDER) || checkClaim(CAN_ADD_WORK_ORDER))" :lineItemProp="lineItemOnEdit"
        modalId="edit-service-order-line-item-form-modal" :serviceOrderId="serviceOrderId" @onHiddenLineItem="onAfterSave"></edit-line>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import { GRID_ID } from '@/shared/constants';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';
  import EditLine from '../ServiceOrderLineItems/index'
  export default {
    components: {
      GridComponent,
      EditLine
    },
    props: {
      serviceOrderId: {
        type:  [Number, String],
        default: 0,
      },
      fromEditPage: {
        type:  Boolean,
        default: false,
      },
    },
    data: () => ({
      selectedRowItemId: 0,
      gridId: GRID_ID.SERVICE_ORDER_LINES_WITH_ITEMS,
      fields: gridFields,
      checkedRowItemIds: [],
      lineItemOnEdit: {}
    }),
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
      ...mapGetters('serviceOrderLines', ['lastOpenedId','serviceOrderLineWithItems', 'serviceOrderLine']),
      itemData() {
        if(this.serviceOrderLineWithItems == undefined || this.serviceOrderLineWithItems.length === 0) return [];
        return this.serviceOrderLineWithItems.map((serviceorder) => ({ ...serviceorder, selected: serviceorder.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapActions('serviceOrderLines', ['deleteServiceOrderLine','getLinesWithItems']),
      // ...mapMutations('serviceOrderLines', ['setLastOpenedId','setItem']),
      ...mapMutations('serviceOrderLines', ['setItem']),
      onEdit(row) {
        //console.log(row);
        //this.selectedRowItemId = row.id;
        this.lineItemOnEdit = {
          id: row.serviceOrderLineItemId,
          serviceItemTypeId: row.serviceItemTypeId || '',
          quantity: row.serviceOrderLineItemQuantity,
          cost: row.serviceOrderLineItemCost || '',
          comments: row.comments || '',
        }
        this.$bvModal.show('edit-service-order-line-item-form-modal');

      },
      async onDelete({id,serviceOrderId}) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete work order line item with id :${id}?`});
        if (deleteConfirmed) {
          const result = await this.deleteServiceOrderLine({id,serviceOrderId});
          this.onAfterSave();
        }
      },
      onAfterSave() {
        this.$emit('onAfterSave');
      },
    },
    watch: {
      async serviceOrderId(newId) {
        if(newId){
          await this.getLinesWithItems(newId);
        } else {
          this.setItem({ resource:'serviceOrderLineWithItems', payload: [] });
        }
      },
      checkedRowItemIds() {
        this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
      },
      serviceOrderLine() {

      }
    },
    async mounted() {
      if(this.serviceOrderId){
        this.getLinesWithItems(this.serviceOrderId);
      }
    },
  };
</script>

<style scoped>
  .service-order-lines-grid {
    height: 185px !important;
  }
</style>
